import "./LoadingSpinner.css";

const LoadingSpinner = (props) => {
  return (
    <div className={`${props.asOverlay && "loading-spinner__overlay"}`}>
      <div className="loading-spinner__container">
        <div className="lds-dual-ring"></div>
        {props.message && (
          <p className="loading-spinner__message">
            {props.message}
            <span className="loading-spinner__dots-animated"></span>
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;